"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var ChartScopeRequest_1 = require("./ChartScopeRequest");
var ChartBreakdownRequest_1 = require("./ChartBreakdownRequest");
var RequestVariables = /** @class */ (function () {
    function RequestVariables(_a) {
        var id = _a.id, identifierType = _a.identifierType, scope = _a.scope, breakdowns = _a.breakdowns;
        var _this = this;
        this.toJSON = function () { return ({
            id: _this.id,
            identifierType: _this.identifierType,
            scope: _this.scope,
            breakdowns: _this.breakdowns
        }); };
        this.id = id;
        this.identifierType = identifierType;
        this.scope = scope;
        this.breakdowns = breakdowns;
    }
    RequestVariables.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, identifierType = _a.identifierType, scope = _a.scope, breakdowns = _a.breakdowns;
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (identifierType && typeof identifierType !== 'string')
            throw new Error('.identifierType must be a string');
        var _scope = ChartScopeRequest_1["default"].fromJSON(scope);
        return new RequestVariables(__assign({ id: id, identifierType: identifierType, scope: _scope }, (breakdowns ? { breakdowns: breakdowns.map(function (b) { return ChartBreakdownRequest_1["default"].fromJSON(b); }) } : null)));
    };
    return RequestVariables;
}());
exports["default"] = RequestVariables;
